import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Button } from '@xingternal/button';
import { Logo } from '@xingternal/platform-layout-logo';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';

import styles from './HeaderLoggedOut.css';
import { getLoginLink } from './utils/getLoginLink';

const HeaderLoggedOut = ({
  // Props
  className,
  hideLoginButton,
  hideSignupButton,
  homeLink,
  intl: { formatMessage },
  loginLink,
  signupLink,
}) => (
  <div className={cx(className, styles.headerPlacebo)}>
    <header className={styles.headerWrapper}>
      <CenterContainer className={styles.header}>
        <div className={styles.logoWrapper}>
          <Logo
            butterfly
            className={cx(styles.logo, styles.butterfly)}
            homeLink={homeLink}
            dataQa="logoMobile"
            size={28}
          />
          <Logo
            className={styles.logo}
            variant="duo"
            size={96}
            homeLink={homeLink}
            dataQa="logo"
          />
        </div>

        {!(hideLoginButton && hideSignupButton) && (
          <nav data-qa="loggedin-nav" className={styles.nav}>
            {!hideLoginButton && (
              <Button
                className={hideSignupButton ? '' : styles.loginLink}
                size="medium"
                href={loginLink}
                variant={hideSignupButton ? 'primary' : 'text'}
              >
                {formatMessage({ id: 'X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK' })}
              </Button>
            )}
            {!hideSignupButton && (
              <Button size="medium" variant="primary" href={signupLink}>
                {formatMessage({ id: 'X_UI_HEADER_REGISTER' })}
              </Button>
            )}
          </nav>
        )}
      </CenterContainer>
    </header>
  </div>
);

HeaderLoggedOut.defaultProps = {
  type: 'standard',
  signupLink: '/signup',
  loginLink: getLoginLink(),
};

HeaderLoggedOut.propTypes = {
  // Props
  className: PropTypes.string,
  hideLoginButton: PropTypes.bool,
  hideSignupButton: PropTypes.bool,
  homeLink: PropTypes.string,
  intl: PropTypes.object.isRequired,
  loginLink: PropTypes.string,
  signupLink: PropTypes.string,
};

export { HeaderLoggedOut };
